import { populateSelectedDatapointsMap } from '../../../../core/components/selection-area/utils/populate-selected-datapoints-map.js';
import { selectedToGroupedDataPoints } from '../../../../core/components/selection-area/utils/selected-bins-to-grouped-data-poins.js';
import { DataPoint } from '../../../../core/types/data-point.js';
import { useSelectState } from '../../../hooks/store/selectors.js';
import { useHistogramFilteredData } from '../../../hooks/useHistogramFilteredData.js';
import { useHistogramXScale } from '../../../hooks/useHistogramXScale.js';
import { useHistogramYScales } from '../../../hooks/useHistogramYScales.js';
import { safeGet } from '../../../providers/HistogramDataProvider.js';
import { HistogramDatapoints } from '../HistogramDatapoints.js';
import { getDataPointDetails } from '../utils/get-datapoints-details.js';
import { isBinWithinRange } from '../utils/is-bin-within-range.js';

export const HistogramSelectionDatapoints = () => {
  const selectState = useSelectState();
  const { xScale } = useHistogramXScale();
  const yScales = useHistogramYScales();
  const filteredData = useHistogramFilteredData();

  const selectedBins = new Map<string, DataPoint[]>();

  if (!selectState) {
    return null;
  }

  const [from, to] = [
    xScale.invert(selectState.start.relative.x),
    xScale.invert(selectState.end.relative.x),
  ];

  for (const series of filteredData.series) {
    const yScale = yScales[safeGet(filteredData.seriesMap, series).scaleIndex];

    for (const bin of series.bins) {
      if (isBinWithinRange(bin, from, to)) {
        populateSelectedDatapointsMap(
          selectedBins,
          `${bin.from}-${bin.to}`,
          getDataPointDetails(yScale, xScale, bin, filteredData.binsMap),
        );
      }
    }
  }

  const highlightedDataPoints = selectedToGroupedDataPoints(selectedBins);

  return <HistogramDatapoints groupedPoints={highlightedDataPoints} />;
};
